import { schema } from 'normalizr';

const company = new schema.Entity('company');

export default company;
